import { WidgetType } from 'domain/entity/widget';
import { LayoutType } from 'domain/entity/layout';

export type ConstraintsPerLayout = {
    type: LayoutType;
    minimumWidth: number;
    minimumHeight: number;
    maximumWidth: number;
    maximumHeight: number;
};

export type WidgetTypeSettings = {
    type: WidgetType;
    constraints: {
        layouts: ConstraintsPerLayout[];
    };
};

class DashboardSettings {
    constructor(readonly widgetTypes: WidgetTypeSettings[]) {}
}

export default DashboardSettings;
